import { images } from '../constants';

const news = [
    {
        id: 1,
        title: '70 milionów na kwiatowy raj w Imielnie',
        content: 'Odnowa dworu, 12 ha parku i ogromny ogród botaniczny. Zobacz zdjęcia z ambitnego projektu.',
        source: 'TuKutno.pl',
        link: 'https://tukutno.pl/pl/11_wiadomosci/15861_70-milionow-na-kwiatowy-raj-odnowa-dworu-12-ha-parku-i-ogrod-botaniczny-foto.html'
    },
    {
        id: 2,
        title: 'Pod Kutnem powstanie największy ogród różany w Polsce',
        content: 'Fundacja Dwór Imielno planuje stworzenie unikatowej atrakcji turystycznej na skalę kraju.',
        source: 'Panorama Kutna',
        link: 'https://panoramakutna.pl/pod-kutnem-powstanie-najwiekszy-ogrod-rozany-w-polsce/'
    },
    {
        id: 3,
        title: 'Mają ambitne plany – największy taki obiekt w Polsce',
        content: 'Szczegóły rewitalizacji i wizja przyszłości zespołu dworsko-parkowego w województwie łódzkim.',
        source: 'Kutno.net.pl',
        link: 'https://kutno.net.pl/wydarzenia/maja-ambitne-plany-w-woj-lodzkim-powstanie-najwiekszy-taki-obiekt-w-polsce/44DwSFup7zR4aqKXmrBT'
    },
    {
        id: 4,
        title: 'Nowa atrakcja turystyczna w łódzkiem',
        content: 'Historyczny dwór w Imielnie przechodzi transformację. To ma być perła regionu.',
        source: 'TuLodz.pl',
        link: 'https://tulodz.pl/lodzkie/nowa-atrakcja-turystyczna-w-lodzkiem-to-ma-byc-najwiekszy-taki-obiekt-w-polsce/SPxAZKFBtJTDeA5kCDPF'
    },
    {
        id: 5,
        title: 'Działania Fundacji Dwór Imielno w regionie',
        content: 'Bieżące relacje i informacje dotyczące inicjatyw podejmowanych przez Fundację na rzecz lokalnej społeczności i zabytków.',
        source: 'Życie Kutna',
        link: 'https://zyciekutna.com.pl/tag/fundacja-dwor-imielno/'
    },
    {
        id: 6,
        title: 'Dwór Imielno wraz z parkiem – nowy projekt w realizacji',
        content: 'Polskie Towarzystwo Różane o postępach prac w Imielnie. Projekt łączy historię z nowoczesną wizją ogrodnictwa.',
        source: 'PTRosa.pl',
        link: 'https://ptrosa.pl/2025/12/10/dwor-imielno-wraz-z-parkiem-nowy-projekt-w-realizacji/'
    },
    {
        id: 7,
        title: 'Gmina Nowe Ostrowy wesprze powstanie ogrodu botanicznego w Imielnie',
        content: 'Podpisano list intencyjny w sprawie współpracy samorządu przy tworzeniu nowego ogrodu botanicznego.',
        source: 'Życie Kutna',
        link: 'https://zyciekutna.com.pl/2025/11/28/gmina-nowe-ostrowy-wesprze-powstanie-ogrodu-botanicznego-w-imielnie-podpisano-list-intencyjny/'
    },
    {
        id: 8,
        image: images.partner8,
        title: 'Dwor Imielno tworzy projekt z misją',
        content: 'Publikacja prezentuje nasze kluczowe inicjatywy, skalę prowadzonych działań oraz realny wpływ, jaki wywieramy na rozwój sektora ogrodniczego i lokalnych społeczności.',
        source: 'BiznesOgrodniczy',
        link: 'https://biznes-ogrodniczy.pl/magazyn/biznes-ogrodniczy-luty-2026/?fbclid=IwY2xjawQk1PVleHRuA2FlbQIxMABicmlkETBLRWtseVE0QWVSVElhS05Wc3J0YwZhcHBfaWQQMjIyMDM5MTc4ODIwMDg5MgABHo6XL3gSq1Ushu3HbYYDB3ADG0dzC9HhnYVCanfOnvcGyBqjKbdYWDIp3dx-_aem_2-6I2XcoU-ULi_toTEf87A#flipbook-df_31078/40/'
    },
    {
        id: 9,
        title: 'To był świat siedemdziesiątych lat (dekada Gierka)',
        content: 'To był świat siedemdziesiątych lat (dekada Gierka)',
        source: 'panoramakutna.pl',
        link: 'https://panoramakutna.pl/w-regionie-moze-powstac-ogrod-rozany-kolejny-krok-w-kierunku-realizacji-projektu-zdjecia/?fbclid=IwY2xjawRdtlVleHRuA2FlbQIxMQBicmlkETBLRWtseVE0QWVSVElhS05Wc3J0YwZhcHBfaWQBMAABHufoGpA9KVqj1Jnyf4fx9XGbW5_W2Ql8YI-FthIs4VZp4jmibzOIRm3eAl5m_aem_-_2_sbAW5f9B7tHIuMT2pw'
    },
    {
        id: 10,
        title: 'Ogród różany w Imielnie – kolejny krok w kierunku realizacji projektu',
        content: 'Ogród różany w Imielnie – kolejny krok w kierunku realizacji projektu',
        source: 'ekutno.pl',
        link: 'https://ekutno.pl/pl/14_kultura/75282_fundacja-dwor-imielno-stworzy-rosarium-ogrod-rozany-w-kutnie.html'
    },
    {
        id: 11,
        title: 'Fundacja Dwór Imielno stworzy rosarium – ogród różany w Kutnie',
        content: 'Fundacja Dwór Imielno stworzy rosarium – ogród różany w Kutnie',
        source: 'tukutno.pl',
        link: 'https://tukutno.pl/pl/11_wiadomosci/19119_rosarium-i-nowe-wydarzenia-efekty-wspolpracy-kdk-i-dworu-imielno.html'
    }
];

export default news;